import React from "react";

const RouteLoader = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center">
        <img
          src={process.env.PUBLIC_URL + "/images/loaders/block-loader.svg"}
          alt="Loading..."
          className="w-12 h-12 mx-auto"
        />
      </div>
    </div>
  );
};

export default RouteLoader;
